import { render, staticRenderFns } from "./TheBreadcrumbs.vue?vue&type=template&id=3c2152a4&scoped=true&lang=pug&"
import script from "./TheBreadcrumbs.vue?vue&type=script&lang=js&"
export * from "./TheBreadcrumbs.vue?vue&type=script&lang=js&"
import style0 from "./TheBreadcrumbs.vue?vue&type=style&index=0&id=3c2152a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2152a4",
  null
  
)

export default component.exports